import React from 'react';
import { useParams } from 'react-router-dom';

import { GetGameChatHistory } from '../../../services/games';
import { ChatState } from '../../../types/state/websocket/chat-state';
import {
  PlayerChatContext,
  PlayerChatContextProps
} from '../../../contexts/player-chat';
import {
  Chat,
  ChatMessageSendEvent,
  ChatMessageTemplateProps
} from '@progress/kendo-react-conversational-ui';
import { generateTitleById } from '../../../utils/game-document/display-languages';
import { PlayerContext } from '../../../contexts/player';
import MessageChat from '../message-chat';
import { MessageTemplate } from '../message-template';
import { GameDocumentContext } from '../../../contexts/game-document';
import { DisplayLanguageContext } from '../../../contexts/display-languages';

interface ChatRoom {
  visibleButtonChat: boolean;
  addNewMessage: (event: ChatMessageSendEvent) => Promise<void>;
}

export const AllPlayersChat = ({
  visibleButtonChat,
  addNewMessage
}: ChatRoom) => {
  const { gameCode } = useParams();

  const [playerState] = React.useContext(PlayerContext);
  const [gameDocumentstate] = React.useContext(GameDocumentContext);
  const [displayLanguageContext] = React.useContext(DisplayLanguageContext);

  const { chatHub } = React.useContext(
    PlayerChatContext
  ) as PlayerChatContextProps;

  const [messages, setMessages] = React.useState<ChatState[]>([]);

  const user = {
    id: playerState?.playerState?.code,
    avatarUrl: playerState?.playerState?.avatarImage
  };

  const renderMessageTemplate = React.useCallback(
    (props: ChatMessageTemplateProps) => (
      <MessageTemplate
        hideChatButton={true}
        currentUserCode={user.id!}
        {...props}
      />
    ),
    [user.id]
  );

  const getChatHistoryAsync = () => {
    let newChats: ChatState[] = [];
    GetGameChatHistory(gameCode!).then((response) => {
      response?.data.forEach((chat) => {
        newChats.push({
          author: {
            id: chat.playerCode,
            name: chat.playerName ?? '',
            avatarUrl: chat.playerAvatar ?? ''
          },
          timestamp: new Date(chat.sentDateUtc),
          group: 'global-chat',
          text: chat.message
        });
      });

      setMessages(newChats);
    });
  };

  React.useEffect(() => {
    if (!chatHub || !gameCode) return;

    chatHub.on('GlobalChatReceived', (data) => {
      const { senderCode, senderName, senderAvatar, message, sentDateUtc } =
        data;
      const chat = {
        author: {
          id: senderCode,
          name: senderName,
          avatarUrl: senderAvatar
        },
        timestamp: new Date(sentDateUtc),
        group: 'global-chat',
        text: message
      };
      setMessages((prev) => [...prev, chat]);
    });
  }, [chatHub, gameCode]);

  React.useEffect(() => {
    getChatHistoryAsync();
  }, []);

  return (
    <div className="h-100 w-100 row m-0 p-0 flex-grow-1 overflow-hidden">
      <div className={`col-12 col-md-12 m-0 p-0`}>
        <div className="d-flex h-100 facilitator-chat-container">
          <Chat
            className={`${!visibleButtonChat ? 'hide-action' : ''} flex-grow-1 w-100 h-100`}
            user={user}
            messages={messages}
            onMessageSend={addNewMessage}
            placeholder={
              generateTitleById(
                '2373ccd3-e73e-403d-bd99-7083f1512a96',
                gameDocumentstate,
                displayLanguageContext.displayLanguageSelected.resources!,
                'game'
              ) || 'Type a message...'
            }
            message={MessageChat}
            messageTemplate={renderMessageTemplate}
          />
        </div>
      </div>
    </div>
  );
};
